import workspaceQuery from '../../queries/salesLedger/AutomatedCreditControlResultWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const AutomatedCreditControlResult: EntityType = {
  type: 'AutomatedCreditControlResult',
  title: 'Automated Credit Control Workflow Results',
  workspaceUrl: '/Customers/AutomatedCustomerCreditControlResult/',
  workspace: workspaceQuery,
  screenReference: 'AUTO_CRED_CONTROL_RESULT',
};

export default AutomatedCreditControlResult;
